/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EmployeePayDetailsWithBatchSummary } from './EmployeePayDetailsWithBatchSummary';
import {
    EmployeePayDetailsWithBatchSummaryFromJSON,
    EmployeePayDetailsWithBatchSummaryFromJSONTyped,
    EmployeePayDetailsWithBatchSummaryToJSON,
    EmployeePayDetailsWithBatchSummaryToJSONTyped,
} from './EmployeePayDetailsWithBatchSummary';

/**
 * 
 * @export
 * @interface CreateEmployeePayDetailResponse
 */
export interface CreateEmployeePayDetailResponse {
    /**
     * 
     * @type {EmployeePayDetailsWithBatchSummary}
     * @memberof CreateEmployeePayDetailResponse
     */
    data: EmployeePayDetailsWithBatchSummary;
}

/**
 * Check if a given object implements the CreateEmployeePayDetailResponse interface.
 */
export function instanceOfCreateEmployeePayDetailResponse(value: object): value is CreateEmployeePayDetailResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function CreateEmployeePayDetailResponseFromJSON(json: any): CreateEmployeePayDetailResponse {
    return CreateEmployeePayDetailResponseFromJSONTyped(json, false);
}

export function CreateEmployeePayDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEmployeePayDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': EmployeePayDetailsWithBatchSummaryFromJSON(json['data']),
    };
}

  export function CreateEmployeePayDetailResponseToJSON(json: any): CreateEmployeePayDetailResponse {
      return CreateEmployeePayDetailResponseToJSONTyped(json, false);
  }

  export function CreateEmployeePayDetailResponseToJSONTyped(value?: CreateEmployeePayDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': EmployeePayDetailsWithBatchSummaryToJSON(value['data']),
    };
}

